import React from 'react';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Row, Col } from 'reactstrap';
import reducer from './reducer';
import saga from './saga';

import { getOffers } from './actions';

import { Search, HorizontalFilter, Paginator, Loader, RequestOffer, SponsorBanner } from 'components';
import { FormattedHTMLMessage } from 'react-intl';
import messages from './messages';
import CarItemList from 'components/CarItemsList';
import { featureAllowed } from 'containers/App/selectors';

import {
  makeSelectOffers,
  makeSelectLoading,
  makeSelectOffersNumber,
} from './selectors';

import { makeSelectSelectedTags } from 'components/HorizontalFilter/selectors';

import './styles.scss';

export class OffersPage extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.loadOffers();
  }

  render() {
    const { offers, loading, total, selectedFilters, featureAllowed } = this.props;

    return (
      <>
        <SponsorBanner />
        <Row id="Offers">
          <Col xl={3} sm={12}>
            <div className="search-margin-top element-box d-md-none d-xl-block" id="search-column">
              <Search />
            </div>
          </Col>
          <Col xl={9} lg={12} md={12} sm={12}>
            <div id="skip-link">
              <a
                href="#search-column"
                className="element-invisible element-focusable"
                aria-label="Vai ai Filtri"
              >
                Vai ai Filtri
              </a>
            </div>
            <div className="element-box-tp position-relative">
              <HorizontalFilter
                results={total}
                id="offers-results"
                label="ordina risultati offerte"
              />
              <Loader loading={loading} />
              {
                !loading &&
                (offers.length ? <CarItemList cars={offers} selectedFilters={selectedFilters} />
                  : <div className="text-center offers-not-found-msg">
                    <FormattedHTMLMessage {...messages.noOfferFound} />
                  </div>)
              }
              {featureAllowed('offer-request') &&
                <RequestOffer />
              }
              <Paginator />
            </div>
          </Col>
        </Row>
      </>
    );
  }
}

OffersPage.propTypes = {};

export function mapDispatchToProps(dispatch) {
  return {
    loadOffers: () => dispatch(getOffers()),
  };
}

const mapStateToProps = createStructuredSelector({
  offers: makeSelectOffers(),
  loading: makeSelectLoading(),
  total: makeSelectOffersNumber(),
  selectedFilters: makeSelectSelectedTags(),
  featureAllowed: (state, featureSlug) => featureAllowed(state, featureSlug),
});

const withReducer = injectReducer({ key: 'offers', reducer });
const withSaga = injectSaga({ key: 'offers', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(OffersPage);
